// import external dependencies
import 'jquery';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import archive from './routes/archive';

// Additional Libraries
import { setup_menu_trigger, show_submenu, subMenuShowHide, closeMenu } from './modules/menu';
import { setup_cookie_notice_popup } from './modules/cookie-notice';

// Swup setup
import { lityPopup } from './modules/page';

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
	home,
	archive,
});

// Generic events - these are loaded once only and would not re-run on Swup page changes
jQuery(document).on('ready', () => {
	// Place one off code here - such as click events for the menu
	setup_menu_trigger();
	show_submenu();
	setup_cookie_notice_popup();
	subMenuShowHide();
	lityPopup();
});

// Load Events
jQuery(document).on('ready', () => routes.loadEvents());





// WEBPACK FOOTER //
// ./scripts/main.js